module.exports = __webpack_public_path__ + "img/estilo_paso3.61100b12.svg";